/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/ip_prefix.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Truncates an IP to a given prefix length.
 *
 * @example
 * ROW ip4 = to_ip("1.2.3.4"), ip6 = TO_IP("fe80::cae2:65ff:fece:feb9")
 * | EVAL ip4_prefix = IP_PREFIX(ip4, 24, 0), ip6_prefix = IP_PREFIX(ip6, 0, 112);
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'ip_prefix',
  signatures: [
    {
      params: [
        {
          name: 'ip',
          type: 'ip',
          optional: false,
        },
        {
          name: 'prefixLengthV4',
          type: 'integer',
          optional: false,
        },
        {
          name: 'prefixLengthV6',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'ip',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
